import { BaseIp, ProIp } from "./ApiURL";


//Post mapping :id
export const webOpacAPI = ProIp + "webOpacAPI/mob/"